import { GraphQLClient } from 'graphql-request'
import Queries from './graphql/queries'
import { mergeDeepRight } from 'ramda'

function getResidentials(payload) {
  return new GraphQLClient('/api/graphql')
    .request(Queries.Residentials, mergeDeepRight({ filter: { status: ['!draft'] } }, payload))
    .then(data => data.ResidentialsPaginate)
}

export { getResidentials }
